module.exports = __webpack_public_path__ + "static/VKR-f355f55cc80c96a906eaf798ddb83a3b.jpg";